<template>
	<div class="indexContainer">
		<Header></Header>

		<div id="myCarousel" class="carousel slide" data-ride="carousel" data-interval="3000">
		    <!-- 轮播（Carousel）指标 -->
		    <ol class="carousel-indicators">
		        <li data-target="#myCarousel" data-slide-to="0" class="active"></li>
		        <li data-target="#myCarousel" data-slide-to="1"></li>
		        <li data-target="#myCarousel" data-slide-to="2"></li>
		        <li data-target="#myCarousel" data-slide-to="3"></li>
		    </ol>
		    <!-- 轮播（Carousel）项目 -->
		    <div class="carousel-inner">
		        <div class="item active">
		            <img src="../../assets/img/index/bg.jpg">
		            <div class="carousel-caption"><a href="javascript:;" @click="showFont()">{{isShown?"文字介绍": "返回"}}<span class="returnBack"></span></a></div>
		            <div class="font-content active">
		            	<img src="../../assets/img/index/content1.png" alt="" />
		            </div>
		            <div class="font-content">
		            	<img src="../../assets/img/index/content2.png" alt="" />
		            </div>
		        </div>
		        <div class="item">
		            <img src="../../assets/img/index/banner2.png">
		        </div>
		        <div class="item">
		            <img src="../../assets/img/index/banner3.jpg">
		        </div>
		        <div class="item">
		            <img src="../../assets/img/index/banner4.jpg">
		        </div>
		    </div>
		    <!-- 轮播（Carousel）导航 -->
		    <a class="left carousel-control" href="#myCarousel" role="button" data-slide="prev">
		        <span class="glyphicon glyphicon-chevron-left" aria-hidden="true"></span>
		        <span class="sr-only">Previous</span>
		    </a>
		    <a class="right carousel-control" href="#myCarousel" role="button" data-slide="next">
		        <span class="glyphicon glyphicon-chevron-right" aria-hidden="true"></span>
		        <span class="sr-only">Next</span>
		    </a>
		</div>

		<div class="indexContentWrapper" data-wow-duration="1s">
			<div class="wrapper-box container" id="CMR-box">
				<div class="left">
					<div class="img-box img-box1">
						<img src="../../assets/img/index/pic1_3.png" alt="" class="wow flipInX" data-wow-duration="1s" data-wow-delay="0.5s"/>
					</div>
					<div class="img-box img-box2">
						<img src="../../assets/img/index/pic1_2.png" alt="" class="wow flipInX" data-wow-duration="1s" data-wow-delay="0.8s"/>
						<img src="../../assets/img/index/pic1_9.png" alt="" class="wow flipInX" data-wow-duration="1s" data-wow-delay="1s"/>
					</div>
					<div class="img-box img-box3">
						<img src="../../assets/img/index/pic1_4.png" alt="" class="wow flipInX" data-wow-duration="1s" data-wow-delay="1.5s"/>
						<img src="../../assets/img/index/pic1_1.png" alt="" class="wow flipInX" data-wow-duration="1s" data-wow-delay="1.7s"/>
						<img src="../../assets/img/index/pic1_8.png" alt="" class="wow flipInX" data-wow-duration="1s" data-wow-delay="1.9s"/>
					</div>
					<div class="img-box img-box4">
						<img src="../../assets/img/index/pic1_5.png" alt="" class="wow flipInX" data-wow-duration="1s" data-wow-delay="2.4s"/>
						<img src="../../assets/img/index/pic1_7.png" alt="" class="wow flipInX" data-wow-duration="1s" data-wow-delay="2.6s"/>
					</div>
					<div class="img-box img-box5">
						<img src="../../assets/img/index/pic1_6.png" alt="" class="wow flipInX" data-wow-duration="1s" data-wow-delay="3s"/>
					</div>
				</div>
				<div class="right wow slideInRight">
					<h3 class="title">CRM</h3>
					<p class="small-title">客户管理系统</p>
					<p class="text">
						CRM对客户的信息进行收集、管理、分析等，帮助企业实现以客户为中心，提高企业的管理方式。系统具有高可控性的数据库、更高的安全性、数据实时更新，满足客户的不同需求，为客户提供“一对一”的个性化服务。
					</p>
					<div class="icon-box">
						<p class="icon-cont">
							<img src="../../assets/img/index/icon1.png" alt="" />
						</p>
						<p class="icon-cont">
							<img src="../../assets/img/index/icon2.png" alt="" />
						</p>
					</div>
					<!--<div class="read-more">
						<router-link class="btn btn-info" to="http://192.168.26.33:8081/shipper/user/login?code=CRM">登录系统</router-link>
					</div>-->
				</div>
				<div class="clear-both"></div>
			</div>

			<div class="wrapper-box" id="OMS-box">
				<div class="container">
					<div class="right wow slideInLeft">
						<p class="text">
							OMS对客户下达的订单进行管理及追踪，动态掌握订单的配送情况；通过对订单的管理和分配，使仓储管理和运输管理有机的结合，使物流管理中各个环节充分发挥作用；系统可以对商户下达的各种指令进行管理、查询、修改 、打印等。
						</p>
						<div class="icon-box">
							<p class="icon-cont">
								<img src="../../assets/img/index/icon3.png" alt="" class="wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="0.5s"/>
							</p>
							<p class="icon-cont">
								<img src="../../assets/img/index/icon4.png" alt="" class="wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="0.8s"/>
							</p>
							<p class="icon-cont">
								<img src="../../assets/img/index/icon5.png" alt="" class="wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="1.4s"/>
							</p>
							<p class="icon-cont">
								<img src="../../assets/img/index/icon6.png" alt="" class="wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="2s"/>
							</p>
						</div>
						<div class="read-more">
							<!--http://192.168.26.33:8081/shipper/user/login?code=OMS&&-->
							<!-- <a target="_blank" class="btn btn-info" href="javascript:;">登录系统</a> -->
						</div>
					</div>
					<div class="left wow slideInRight">
						<h3 class="title">OMS</h3>
						<p class="small-title">订单管理系统</p>
						<div class="img-box">
							<img src="../../assets/img/index/pic2_2.jpg" alt="" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s"/>
						</div>
					</div>
					<div class="clear-both"></div>
				</div>
			</div>

			<div class="wrapper-box" id="WMS-box">
				<div class="container">
					<div class="left wow slideInRight">
						<h3 class="title">WMS</h3>
						<p class="small-title">仓库管理系统</p>
						<div class="icon-box">
							<p class="icon-cont">
								<img src="../../assets/img/index/icon7.png" alt="" class="wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="0.5s"/>
							</p>
							<p class="icon-cont">
								<img src="../../assets/img/index/icon8.png" alt="" class="wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="0.8s"/>
							</p>
							<p class="icon-cont">
								<img src="../../assets/img/index/icon9.png" alt="" class="wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="1.4s"/>
							</p>
							<p class="icon-cont">
								<img src="../../assets/img/index/icon10.png" alt="" class="wow fadeInUp" data-wow-duration="0.5s" data-wow-delay="2s"/>
							</p>
						</div>
						<div class="img-content-box">
							<div class="img-box img-box1">
								<img src="../../assets/img/index/pic3_4.png" alt="" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s"/>
							</div>
							<div class="img-box img-box2">
								<img src="../../assets/img/index/pic3_5.png" alt="" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s"/>
							</div>
							<div class="img-box img-box3">
								<img src="../../assets/img/index/pic3_6.png" alt="" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s"/>
							</div>
						</div>
					</div>
					<div class="right wow slideInLeft">
						<div class="img-content-box">
							<div class="img-box img-box1">
								<img src="../../assets/img/index/pic3_1.png" alt="" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s"/>
							</div>
							<div class="img-box img-box2">
								<img src="../../assets/img/index/pic3_2.png" alt="" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s"/>
							</div>
							<div class="img-box img-box3">
								<img src="../../assets/img/index/pic3_3.png" alt="" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s"/>
							</div>
						</div>
						<p class="text">
							WMS支持云端部署，并支持多层级、多仓库、多货主多模式。<br />
							系统可根据不同级别/类型的仓库灵活配置不同的作业流程。<br />
							系统可根据不同业务场景配置入库收货、出库发货流程。
						</p>

						<div class="read-more">
							<!--http://192.168.26.33:8081/shipper/user/login?code=WMS&&-->
							<a target="_blank" class="btn btn-info" href="http://114.247.42.145:18083">登录系统</a>
						</div>
					</div>

					<div class="clear-both"></div>
				</div>
			</div>

			<div class="wrapper-box" id="TMS-box">
				<div class="bg-img">
					<img src="../../assets/img/index/pic4_2.jpg"/>
					<img src="../../assets/img/index/pic4_1.jpg"/>
				</div>
				<div class="container">
					<div class="left wow slideInLeft">
						<p class="text">
							TMS实现在配送中全程可视化，交接高效、便捷，全面兼容手机APP司机端，实现可视化配送管理。
						</p>
						<div class="read-more">
							<a target="_blank" class="btn btn-info" href="http://www.so56.net/shipper/user/login?code=TMS&&">登录系统</a>
						</div>
					</div>
					<div class="right wow slideInRight">
						<h3 class="title">TMS</h3>
						<p class="small-title">运输管理系统</p>
						<div class="img-content-box">
							<div class="img-box img-box1">
								<img src="../../assets/img/index/pic4_3.png" alt="" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s"/>
							</div>
						</div>

					</div>
					<div class="clear-both"></div>
				</div>
				<div class="clear-both"></div>
			</div>

			<div class="wrapper-box container" id="BMS-box">
				<div class="left wow slideInLeft">
					<h3 class="title">FMS</h3>
					<p class="small-title">财务管理系统</p>
					<p class="text">
						FMS设置标准化计费规则，避免人为误差，系统支持按照客户或者区域等多视角的数据展现，费用审核机制保证数据的安全性和准确性。
					</p>
					<div class="icon-box">
						<p class="icon-cont">
							<img src="../../assets/img/index/icon11.png" alt="" />
						</p>
						<p class="icon-cont">
							<img src="../../assets/img/index/icon12.png" alt="" />
						</p>
						<p class="icon-cont">
							<img src="../../assets/img/index/icon13.png" alt="" />
						</p>
						<p class="icon-cont">
							<img src="../../assets/img/index/icon14.png" alt="" />
						</p>
					</div>
					<div class="read-more">
						<!--http://192.168.26.33:8081/shipper/user/login?code=BMS&&-->
						<!-- <a target="_blank" class="btn btn-info" href="javascript:;">登录系统</a> -->
					</div>
				</div>
				<div class="right wow slideInRight">
					<div class="img-content-box">
						<div class="img-box img-box1">
							<img src="../../assets/img/index/pic5.jpg" alt="" class="wow fadeInUp" data-wow-duration="0.8s" data-wow-delay="0.5s"/>
						</div>
					</div>
				</div>
			</div>

			<div class="wrapper-box" id="DAS-box">
				<div class="container">
					<div class="left wow slideInUp">
						<div class="cont">
							<h3 class="title">DAS</h3>
							<p class="small-title">数据分析系统</p>
							<p class="text">
								DAS对订单数据、司机行车数据、财务数据、<br />业务数据等进行统计分析，帮助用户全盘掌控业务。
							</p>
							<div class="icon-box">
								<p class="icon-cont">
									<img src="../../assets/img/index/icon15.png" alt="" />
								</p>
								<p class="icon-cont">
									<img src="../../assets/img/index/icon16.png" alt="" />
								</p>
								<p class="icon-cont">
									<img src="../../assets/img/index/icon17.png" alt="" />
								</p>
							</div>
							<!--<div class="read-more">
								<router-link class="btn btn-info" to="/">登录系统</router-link>
							</div>-->
						</div>
						<img src="../../assets/img/index/pic6_2.png" class="bg-img"/>
					</div>
				</div>
				<div class="clear-both"></div>
			</div>

		</div>
    <!-- <Suggest></Suggest> -->
		<Footer></Footer>
	</div>
</template>

<script>
	import Header from '../../components/common/header.vue'
	import Footer from '../../components/common/footer.vue'
  // import Suggest from '../../components/common/suggest.vue'
	import { WOW } from '../../assets/js/wow.min.js'

	export default{
		data() {
			return {
				isShown: true
			}
		},
		components: {
			Header,
			Footer,
      // Suggest
		},
		created: function(){
			new WOW({live: false}).init();
		},
		mounted: function(){
			new WOW({live: false}).init();
			this.axios.get('http://192.168.26.33:8081/admin/idx/listUserMenu').then(response =>{
				console.log(response.data)
			}).catch(error => {
				console.log("err")
			})
		},
		methods: {
			showFont: function(){
				if(this.isShown){
					$(".carousel-inner .font-content").eq(1).addClass('active').siblings().removeClass("active");
				}else{
					$(".carousel-inner .font-content").eq(0).addClass('active').siblings().removeClass("active");
				}
				this.isShown = !this.isShown;
			}
		}
	}

</script>

<style scoped>
	@import url("../../assets/css/animate.min.css");
	.carousel-inner>.item>a>img, .carousel-inner>.item>img, .img-responsive, .thumbnail>img, .thumbnail a>img{
	    width: 100%;
	}
	.carousel-caption{
		width: 140px;
	    padding: 0;
	    height: 40px;
	    border: 1px solid #fff;
	    line-height: 40px;
	    background: rgba(255,255,255,0.1);
    	font-size: 18px;
    	z-index: 20;
    	bottom: 15%;
	}
	.carousel-inner .font-content{
		width: 63%;
		position: absolute;
		top: 20%;
		left: 50%;
		transform: translate(-50%, 0);
		z-index: 2;
		display: none;
		text-align: center;
	}
	.carousel-inner .font-content img{
		max-width: 100%;
	}
	.carousel-inner .font-content.active{
		display: block;
	}
	.carousel-caption a{
		color: #fff;
		display: block;
	}
	.carousel-caption a::before{
		display: block;
		position: absolute;
		top: 0px;
		right: 0px;
		height: 100%;
		width: 0px;
		z-index: -1;
		content: "";
		color: #000 !important;
		background: #ff6600;
		-webkit-transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1) 0s;
		-o-transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1) 0s;
		transition: all 0.4s cubic-bezier(0.42, 0, 0.58, 1) 0s;
	}
	.carousel-caption a:hover::before{
		left: 0%;
		right: auto;
		width: 100%;
	}
	.returnBack{
		display: inline-block;
		width: 22px;
		height: 14px;
		margin-left: 5px;
		background: url(../../assets/img/images/arrow.png) no-repeat;
		background-size: 100%;
	}
	.carousel-indicators li{
		width: 18px;
	    height: 18px;
	    margin: 0 20px;
	}
	.carousel-indicators .active{
		background-color: #ff6600;
	    border: none;
	    width: 18px;
	    height: 18px;
	    margin: 0 20px;
	}
	.wrapper-box{
		padding: 50px 0;
		display: flex;
	}
	.wrapper-box .left{

	}
	#CMR-box .left{
		float: left;
		position: relative;
		flex: 1;
		height: 519px;
	}
	#CMR-box .left .img-box{
		position: absolute;
		left: 0;
		width: 100%;
		text-align: center;
		font-size: 0;
	}
	#CMR-box .left .img-box1{
		top: 0;
	}
	#CMR-box .left .img-box2{
		top: 85.5px;
	}
	#CMR-box .left .img-box3{
		top: 170.5px;
	}
	#CMR-box .left .img-box img{
		position: relative;
	}
	#CMR-box .img-box2 img, #CMR-box .img-box4 img{
		left: 1px;
	}
	#CMR-box .img-box2 img:nth-of-type(2), #CMR-box .img-box4 img:nth-of-type(2){
		left: -2px;
	}
	#CMR-box .img-box3 img:nth-of-type(1){
		left: 3px;
	}
	#CMR-box .img-box3 img:nth-of-type(3){
		left: -3px;
	}
	#CMR-box .left .img-box4{
		top: 255.5px;
	}
	#CMR-box .left .img-box5{
		top: 340px;
	}
	#CMR-box .right{
		flex: 0 0 40%;
	}
	.wrapper-box .title{
		font-size: 50px;
    	color: #061f3e;
	}
	.wrapper-box .small-title{
		font-size: 18px;
    	color: #979ea7;
	}
	.wrapper-box .text{
		color: #666;
	    font-size: 16px;
	    line-height: 40px;
	    text-align: justify;
	}
	.wrapper-box .icon-box{
		margin: 10px 0;
	}
	.wrapper-box .icon-box .icon-cont{
		display: inline-block;
		width: 100px;

	}
	#OMS-box{
		background: url(../../assets/img/index/pic2_1.jpg) no-repeat;
		background-size: cover;
		margin-bottom: 50px;
	}
	#OMS-box .container, #WMS-box .container{
	 	display: flex;
	}
	#OMS-box .text{
		color: #fff;
	}
	#OMS-box .left{
		flex: 1;
	}
	#OMS-box .right{
		flex: 0 0 40%;
		margin-right: 10%;
		position: relative;
	}
	#OMS-box .title, #OMS-box .small-title{
		color: #fff;
	}
	#OMS-box .title{
		margin-top: 0;
	}
	#OMS-box .small-title{
		margin-bottom: 15px;
	}
	#OMS-box .animated .img-box{
		display: inline-block;
		width: 80%;
		position: absolute;
	}
	#OMS-box .img-box img{
		width: 100%;
	}
	#WMS-box .left, #WMS-box .right{
		flex: 1;
	}
	#WMS-box .animated .img-content-box{
		width: 70%;
		position: relative;
		margin-bottom: 150px;
	}
	#WMS-box .animated .img-box img{
		width: 100%;
	}
	#WMS-box .left.animated .img-box2{
		position: absolute;
		top: 22%;
	    right: -30%;
	    width: 60%;
	}
	#WMS-box .left.animated .img-box3{
		position: absolute;
	    bottom: -14%;
	    right: -6%;
	    width: 40%;
	}
	#WMS-box .right.animated .img-box2{
		position: absolute;
		bottom: -22%;
	    right: -3%;
	    width: 45%;
	}
	#WMS-box .right.animated .img-box3{
		position: absolute;
	    bottom: -23%;
	    left: -2%;
	    width: 45%;
	}
	#TMS-box{
		position: relative;
		margin-bottom: 100px;
	}
	#TMS-box .container{
		display: flex;
	}
	#TMS-box .bg-img img{
		width: 52%;
    	margin-top: 50px;
	}
	#TMS-box .bg-img{
		position: absolute;
		width: 100%;
	    left: 0;
	    font-size: 0;
	}
	#TMS-box .bg-img img:nth-of-type(2){
	    margin-top: -50px;
	    width: 43%;
	    position: absolute;
	    right: 0;
	}
	#TMS-box .animated .img-content-box{
		position: absolute;
	    top: -36%;
	    left: -49%;
	    width: 112%;
	}
	#TMS-box .animated .img-content-box img{
		width: 100%;
	}
	#TMS-box .left, #TMS-box .right{
		flex: 1;
	}
	#TMS-box .left{
		margin-top: 100px;
    	color: #fff;
	}
	#TMS-box .left .text{
		color: #fff;
		width: 45%;
	}
	#TMS-box .right{
		text-align: right;
	}
	#TMS-box .title, #TMS-box .small-title{
		color: #fff;
	}
	#BMS-box .left{
		margin-right: 10%;
		flex: 0 0 40%;
	}
	#BMS-box .right{
		flex: 1;
	}
	#BMS-box .right .img-box img{
		width: 100%;
	}
	#DAS-box{
		background: url("../../assets/img/index/pic6_1.jpg") no-repeat center center;
	    background-size: 100% 70%;
	    padding: 0;
	    margin: 50px 0;
	}
	#DAS-box .left{
		width: 80%;
		margin: 0 auto;
		background: #fff;
		border: 1px solid #02387f;
		border-radius: 3px;
		padding: 30px 0;
		padding-top: 20px;
		position: relative;
	}
	#DAS-box .left .cont{
		margin: 0 auto;
		text-align: center;
		width: 375px;
	}
	#DAS-box .text{
		text-align: center;
	    margin: 25px 0;
	}
	#DAS-box .icon-box{
		margin-bottom: 20px;
	}
	#DAS-box .icon-cont{
		font-size: 0;
	}
	#DAS-box .left .bg-img{
		position: absolute;
		right: 10px;
		bottom: 10px;
	}
	@media (max-width: 1400px) {
		.wrapper-box .text{
			line-height: 30px;
		}
		.wrapper-box .icon-box .icon-cont{
			width: 15%;
			margin-right: 2%;
		}
		.wrapper-box .icon-box .icon-cont img{
			width: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/pages/index.vue